import { useEffect, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import AuthContext from "../../components/auth-context";
import LandingPurchaseTicketApi from "../../api/landing-purchase-ticket";

const PayPage: React.FC = () => {
  const { lineId } = useParams<{ lineId: string }>();
  const navigate = useNavigate();
  const context = useContext(AuthContext);

  useEffect(() => {
    if (!lineId) return;

    const id = parseInt(lineId);
    if (isNaN(id)) return;

    new LandingPurchaseTicketApi().get(id).then((ticket) => {
      console.log("ticket", ticket);
      if (ticket.errorMessage) {
        console.error("خطا:", ticket.errorMessage);
        return;
      }

      if (ticket.ticketStatus === 2) {
        window.location.href = `https://internet.sepanta.com/purchase/Detail/${ticket.receiptId}`;
      } else if (ticket.ticketStatus === 1) {
        navigate(`/landing-payment/${ticket.receiptId}`);
      }
    });
  }, [lineId]);

  return (
    <div>
      <h2>در حال بررسی وضعیت پرداخت...</h2>
    </div>
  );
};

export default PayPage;
